<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              people_alt
            </v-icon>
            <span class="title">Data Atlet & Pelatih</span>
          </v-card-title>
          <v-tabs
            v-model="tabpenduduk"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-penduduk">
              Daftar Data
              <v-icon large>how_to_reg</v-icon>
            </v-tab>
            <v-tab href="#tab-addformnew">
              Tambah Data
              <v-icon large>group_add</v-icon>
            </v-tab>
            <v-tab href="#tab-importnew">
              Import Data
              <v-icon large>cloud_upload</v-icon>
            </v-tab>
            <v-tab href="#tab-verifikasi">
              Verifikasi Data
              <v-icon large>group</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabpenduduk">
            <v-tab-item value="tab-penduduk">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="searchpenduduk.cabang_olga"
                          :items="listolga"
                          item-value="nama_olga"
                          item-text="nama_olga"
                          label="Cabang Olahraga">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="searchpenduduk.nik"
                          name="NIK"
                          label="NIK">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="searchpenduduk.nama"
                          name="nama"
                          label="Nama">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          color="success"
                          class="mt-1"
                          @click="getPenduduk('ya')">
                          <v-icon left dark>search</v-icon>
                          Cari
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.dataatlet">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.dataatlet"
                          :headers="headers"
                          :items="datalist"
                          :search="search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'PendudukDetailAdmin', query: { nik: item.nik }}"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addformnew">
              <v-stepper v-model="e6" vertical>
                <v-stepper-step :complete="e6 > 1" step="1">
                  Tipe Data
                  <!-- <small>Summarize if needed</small> -->
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-form
                    ref="step1"
                    v-model="steps.form1"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          :items="listjenisdata"
                          name="jenisdata"
                          v-model="addpenduduk.jenisdata"
                          label="Jenis Data *"
                          :rules="[rules.required]">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="primary"
                      large
                      :disabled="!steps.form1"
                      @click="checkStep('step1')">
                      Berikutnya
                    </v-btn>
                  </v-form>
                </v-stepper-content>
                <v-stepper-step :complete="e6 > 2" step="2">Data Diri</v-stepper-step>
                <v-stepper-content step="2">
                  <v-form
                    ref="step2"
                    v-model="steps.form2"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="addpenduduk.nik"
                          :counter="16"
                          :rules="[rules.required, rules.nik]"
                          label="NIK *"
                          name="nik"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="addpenduduk.nama"
                          :rules="[rules.required]"
                          label="Nama *"
                          name="nama"
                          required>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="addpenduduk.cabang_olga"
                          :items="listolga"
                          item-value="nama_olga"
                          item-text="nama_olga"
                          label="Cabang Olahraga">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-select
                          :items="liststatus"
                          name="status"
                          v-model="addpenduduk.status_menikah"
                          label="Status *">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="addpenduduk.tempat_lahir"
                          label="Tempat lahir *"
                          :rules="[rules.required]"
                          name="tempatlahir"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-menu
                          v-model="datepick.tgllahir"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="addpenduduk.tanggal_lahir"
                              label="Tanggal lahir *"
                              readonly
                              v-on="on">
                            </v-text-field>
                          </template>
                          <v-date-picker
                            ref="birthday"
                            :max="datepick.date"
                            name="tgllahir"
                            v-model="addpenduduk.tanggal_lahir"
                            @input="datepick.tgllahir = false">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          :items="listkelamin"
                          name="kelamin"
                          v-model="addpenduduk.kelamin"
                          label="Jenis kelamin">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-select
                          :items="listagama"
                          v-model="addpenduduk.agama"
                          name="agama"
                          label="Agama">
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          :items="listpendidikan"
                          name="pendidikan"
                          v-model="addpenduduk.pendidikan"
                          label="Pendidikan">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="addpenduduk.pekerjaan"
                          :items="listpekerjaan"
                          item-value="nama_kerja"
                          item-text="nama_kerja"
                          label="Pekerjaan">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="addpenduduk.email"
                          label="E-mail"
                          name="email"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="addpenduduk.phone"
                          label="Telephone *"
                          name="telephone"
                          :rules="[rules.phone]"
                          :counter="12"
                          required>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="error"
                      class="mr-4"
                      large
                      @click="backStep()">
                      Kembali
                    </v-btn>
                    <v-btn
                      color="primary"
                      large
                      :disabled="!steps.form2"
                      @click="checkStep('step2')">
                      Berikutnya
                    </v-btn>
                  </v-form>
                </v-stepper-content>
                <v-stepper-step :complete="e6 > 3" step="3">Alamat Sesuai KTP</v-stepper-step>
                <v-stepper-content step="3">
                  <v-form
                    ref="step3"
                    v-model="steps.form3"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="addpenduduk.pos_ktp"
                          :items="listkodepos"
                          :hint="`${addpenduduk.pos_ktp.kecamatan}, ${addpenduduk.pos_ktp.kabupaten}`"
                          persistent-hint
                          item-value="kodepos"
                          item-text="kodepos"
                          :rules="[rules.required]"
                          label="Kode Pos *"
                          return-object
                          @change="getKelurahanpos(addpenduduk.pos_ktp, 'ktp')">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="addpenduduk.kel_ktp"
                          :items="listkelurahan"
                          item-value="kelurahan"
                          item-text="kelurahan"
                          :rules="[rules.required]"
                          label="Kelurahan *"
                          @change="getBanjarkel(addpenduduk.kel_ktp, 'ktp')">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :disabled="(addpenduduk.pos_ktp) ? true : false"
                          v-model="addpenduduk.kec_ktp"
                          label="Kecamatan *"
                          name="ktpkec"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :disabled="(addpenduduk.pos_ktp) ? true : false"
                          v-model="addpenduduk.kab_ktp"
                          label="Kabupaten *"
                          name="ktpkab"
                          required>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="addpenduduk.banjar_ktp"
                          :items="listbanjar"
                          item-value="nama_banjar"
                          item-text="nama_banjar"
                          :rules="[rules.required]"
                          label="Banjar *">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="addpenduduk.alamat"
                          auto-grow
                          label="Alamat *"
                          :rules="[rules.required]"
                          rows="1">
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="error"
                      class="mr-4"
                      large
                      @click="backStep()">
                      Kembali
                    </v-btn>
                    <v-btn
                      color="primary"
                      large
                      :disabled="!steps.form3"
                      @click="checkStep('step3')">
                      Berikutnya
                    </v-btn>
                  </v-form>
                </v-stepper-content>
                <v-stepper-step step="4">Upload Berkas</v-stepper-step>
                <v-stepper-content step="4">
                  <alertsp :alertdata="alertdata"></alertsp>
                  <v-form
                    ref="step4"
                    v-model="steps.form4"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input
                          v-model="addpenduduk.file_ktp"
                          :rules="rules.files"
                          accept="image/png, image/jpeg, image/bmp"
                          placeholder="Pilih file"
                          prepend-icon="mdi-camera"
                          label="Berkas KTP"
                          show-size>
                        </v-file-input>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="error"
                      class="mr-4"
                      large
                      @click="backStep()">
                      Kembali
                    </v-btn>
                    <v-btn
                      color="primary"
                      large
                      :disabled="!steps.form4"
                      @click="submitAddNew">
                      Simpan
                    </v-btn>
                  </v-form>
                </v-stepper-content>
              </v-stepper>
            </v-tab-item>
            <v-tab-item value="tab-importnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="3" v-if="impatlet.lokasi">
                        <v-autocomplete
                          prepend-icon="location_on"
                          v-model="impatlet.lokasi"
                          :items="listkelurahanall"
                          :hint="`${impatlet.lokasi.kecamatan}, ${impatlet.lokasi.kabupaten}`"
                          persistent-hint
                          item-text="kelurahan"
                          :rules="[rules.required]"
                          label="Kelurahan"
                          return-object
                          single-line>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-file-input
                          v-model="impatlet.file"
                          :hint="'Pilih file data'"
                          persistent-hint
                          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          label="Select"
                          show-size>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          :disabled="loading.impcheck"
                          large
                          block
                          color="primary"
                          class="mt-1"
                          @click="uploadDataCheck">
                          <v-icon left dark>cloud_upload</v-icon>
                          Upload
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          color="yellow"
                          :href="urltemplate"
                          target="_blank"
                          class="mt-1">
                          <v-icon left dark>cloud_download</v-icon>
                          Template
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="loading.impcheck || loading.impsubmit">
                      <v-col cols="12" class="text-center">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </v-col>
                    </v-row>
                    <v-row v-if="!loading.impsubmit && impresult">
                      <v-col cols="12">
                        <v-simple-table class="mt-3">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Total data</th>
                                <th class="text-left">Berhasil</th>
                                <th class="text-left">Duplikat NIK</th>
                                <th class="text-left">Gagal</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <b>{{ impresult.total }}</b>
                                </td>
                                <td>
                                  <b>{{ impresult.berhasil }}</b>
                                </td>
                                <td>
                                  <b>{{ impresult.nikexist }}</b>
                                  <span v-if="impresult.nikexistarr.length > 0">
                                    ( {{ impresult.nikexistarr.join(', ') }} )
                                  </span>
                                </td>
                                <td>
                                  <b>{{ impresult.other }}</b>
                                  <span v-if="impresult.otherarr.length > 0">
                                    ( {{ impresult.otherarr.join(', ') }} )
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-row v-if="!loading.impcheck">
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="impatlet.search"
                          prepend-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          :disabled="!impatlet.data.length || loading.impsubmit"
                          large
                          block
                          color="success"
                          class="mt-1"
                          @click="importDataAtlet">
                          <v-icon left dark>import_export</v-icon>
                          Import
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          :disabled="!impatlet.data.length || loading.impsubmit"
                          large
                          block
                          color="error"
                          class="mt-1"
                          @click="clearDataAtlet">
                          <v-icon left dark>clear</v-icon>
                          Clear
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="!loading.impcheck">
                      <v-col cols="12">
                        <v-data-table
                          :headers="headerimp"
                          :items="impatlet.data"
                          :search="impatlet.search">
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-verifikasi">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="searchver.cabang_olga"
                          :items="listolga"
                          item-value="nama_olga"
                          item-text="nama_olga"
                          label="Cabang Olahraga">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="searchver.nik"
                          name="NIK"
                          label="NIK">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="searchver.nama"
                          name="nama"
                          label="Nama">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          color="success"
                          class="mt-1"
                          @click="getPenduduk('tidak')">
                          <v-icon left dark>search</v-icon>
                          Cari
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.dataatlet">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.dataatlet"
                          :headers="headers"
                          :items="datalistver"
                          :search="search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'PendudukDetailAdmin', query: { nik: item.nik }}"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'PendudukAdmin',
  data: () => ({
    e6: 1,
    steps: {
      form1: false,
      form2: false,
      form3: false,
      form4: false,
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertcheck: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      dataatlet: false,
      impcheck: false,
      impsubmit: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    search: '',
    headers: [
      { text: 'NIK', value: 'nik' },
      { text: 'Nama', value: 'nama' },
      { text: 'Tgl.Lahir', value: 'tanggal_lahir' },
      { text: 'Kelamin', value: 'kelamin' },
      { text: 'Kelurahan', value: 'kel_ktp' },
      { text: 'Cabang', value: 'cabang_olga' },
      { text: 'Verifikasi', value: 'status_ver' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    headerimp: [
      { text: 'Jenis Data', value: 'jenisdata' },
      { text: 'NIK', value: 'nik' },
      { text: 'Nama', value: 'nama' },
      { text: 'Cabang Olahraga', value: 'cabang_olga' },
      { text: 'Tanggal Lahir', value: 'tanggal_lahir' },
      { text: 'Kelamin', value: 'kelamin' },
      { text: 'Alamat', value: 'alamat' },
    ],
    listkelurahanall: [],
    datalist: [],
    datalistver: [],
    liststatusadat: [],
    listkodepos: [],
    listkodeposadat: [],
    listkelurahan: [],
    listkelurahanadat: [],
    listbanjar: [],
    listbanjaradat: [],
    listpekerjaan: [],
    listolga: [],
    listjenisdata: ['atlet', 'pelatih'],
    liststatus: ['Belum Menikah', 'Menikah', 'Cerai'],
    listkelamin: ['L', 'P'],
    listagama: ['Hindu', 'Budha', 'Kristen', 'Katolik', 'Islam', 'Other'],
    listpendidikan: ['SD', 'SLTP', 'SLTA', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3', 'Tidak Sekolah'],
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    berkas: [],
    isadatdisabled: true,
    searchpenduduk: {
      cabang_olga: '',
      nik: '',
      nama: '',
      status_ver: 'ya',
    },
    searchver: {
      cabang_olga: '',
      nik: '',
      nama: '',
      status_ver: 'tidak',
    },
    addpenduduk: {
      jenisdata: '',
      cabang_olga: '',
      nik: '',
      nama: '',
      tanggal_lahir: '',
      tempat_lahir: '',
      kelamin: 'L',
      agama: 'Hindu',
      pendidikan: 'SLTA',
      pekerjaan: '',
      email: '',
      phone: '',
      status_menikah: '',
      alamat: '',
      kab_ktp: '',
      kec_ktp: '',
      kel_ktp: '',
      pos_ktp: '',
      banjar_ktp: '',
      status_adat: '',
      alamat_adat: '',
      kab_adat: '',
      kec_adat: '',
      kel_adat: '',
      pos_adat: '',
      banjar_adat: '',
      file_ktp: null,
    },
    impatlet: {
      file: null,
      data: [],
      search: '',
      lokasi: null,
    },
    impresult: null,
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length === 16 || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
      ],
    },
    tabpenduduk: null,
    dmodal: {
      penduduk: false,
      detail: false,
    },
    dmodaldata: {
      penduduk: null,
      detail: null,
    },
    urltemplate: '',
  }),
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    this.initFuction();
    this.getKodepos();
    this.getPekerjaan();
    this.getOlga();
    // this.getStatusAdat();
    this.getKelurahan();
    this.urltemplate = this.api + '/upload/template/importatlet.xlsx';
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    initFuction() {
      this.addpenduduk.jenisdata = this.listjenisdata[0];
      this.addpenduduk.status_menikah = this.liststatus[0];
    },
    uploadDataCheck() {
      this.impatlet.data = [];
      this.loading.impcheck = true;
      this.alertcheck.show = false;
      if (this.tokenscr) {
        const dataadd = this.impatlet;
        const formData = new FormData();
        // file
        formData.append('file_upload', dataadd.file);
        this.axios
          .post(
            this.api + '/api/penduduk/uploadcheck',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  let datalist = null;
                  for (let i = 1; i < resdata.data.length; i++) {
                    datalist = {
                      jenisdata: resdata.data[i][0],
                      nik: resdata.data[i][1],
                      nama: resdata.data[i][2],
                      cabang_olga: resdata.data[i][3],
                      tanggal_lahir: resdata.data[i][4],
                      kelamin: resdata.data[i][5],
                      alamat: resdata.data[i][6],
                    };
                    this.impatlet.data.push(datalist);
                  }
                }
              } else {
                this.alertcheck.show = true;
                this.alertcheck.type = 'error';
                this.alertcheck.text = resdata.message;
              }
            } else {
              this.alertcheck.show = true;
              this.alertcheck.type = 'error';
              this.alertcheck.text = 'Internal services error!';
            }
            this.loading.impcheck = false;
          })
          .catch((error) => {
            this.loading.impcheck = false;
            this.alertcheck.show = true;
            this.alertcheck.type = 'error';
            this.alertcheck.text = 'Internal services error!';
          });
      } else {
        this.loading.impcheck = false;
        this.alertcheck.show = true;
        this.alertcheck.type = 'error';
        this.alertcheck.text = 'Invalid token!';
      }
    },
    importDataAtlet() {
      this.alertcheck.show = false;
      this.impresult = null;
      if (this.impatlet.data.length > 0) {
        this.loading.impsubmit = true;
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/penduduk/import',
              qs.stringify(
                {
                  listdata: this.impatlet.data,
                  lokasi: this.impatlet.lokasi,
                },
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.impresult = resdata.data;
                  // console.log(this.impresult);
                } else {
                  this.alertcheck.show = true;
                  this.alertcheck.type = 'error';
                  this.alertcheck.text = resdata.message;
                }
              } else {
                this.alertcheck.show = true;
                this.alertcheck.type = 'error';
                this.alertcheck.text = 'Internal services error!';
              }
              this.loading.impsubmit = false;
            })
            .catch((error) => {
              this.loading.impsubmit = false;
              this.alertcheck.show = true;
              this.alertcheck.type = 'error';
              this.alertcheck.text = 'Internal services error!';
            });
        } else {
          this.loading.impsubmit = false;
          this.alertcheck.show = true;
          this.alertcheck.type = 'error';
          this.alertcheck.text = 'Invalid token!';
        }
      } else {
        this.alertcheck.show = true;
        this.alertcheck.type = 'error';
        this.alertcheck.text = 'Data kosong!';
      }
    },
    clearDataAtlet() {
      this.impatlet.data = [];
      this.impatlet.search = '';
      this.impatlet.file = null;
      this.impresult = null;
    },
    changeKtpAdat() {
      if (this.addpenduduk.ktpadat === true) {
        this.copyKtpAdat(true);
      } else {
        this.copyKtpAdat(false);
      }
    },
    copyKtpAdat(iscopy) {
      if (iscopy === true) {
        if (this.addpenduduk.status_adat === 'Krama Adat') {
          this.isadatdisabled = true;
        } else {
          this.isadatdisabled = false;
        }
        // list
        this.listkelurahanadat = this.listkelurahan;
        this.listbanjaradat = this.listbanjar;
        // data
        this.addpenduduk.alamat_adat = this.addpenduduk.alamat;
        this.addpenduduk.kab_adat = this.addpenduduk.kab_ktp;
        this.addpenduduk.kec_adat = this.addpenduduk.kec_ktp;
        this.addpenduduk.kel_adat = this.addpenduduk.kel_ktp;
        this.addpenduduk.pos_adat = this.addpenduduk.pos_ktp;
        this.addpenduduk.banjar_adat = this.addpenduduk.banjar_ktp;
      } else {
        this.isadatdisabled = false;
      }
    },
    changeStatusAdat() {
      if (this.addpenduduk.status_adat === 'Krama Adat') {
        this.addpenduduk.ktpadat = true;
      } else {
        this.addpenduduk.ktpadat = false;
      }
      this.changeKtpAdat();
      // console.log(this.addpenduduk.status_adat);
    },
    checkStep(scope) {
      if (this.$refs[scope].validate()) {
        this.e6++;
      }
    },
    backStep() {
      this.e6--;
    },
    getBanjarkel(kel, type) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/banjar',
            {
              params: {
                kelurahan: kel,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (type === 'ktp') {
                  this.listbanjar = resdata.data;
                } else {
                  this.listbanjaradat = resdata.data;
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getKelurahanpos(kode, type) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/kelurahan',
            {
              params: {
                kodepos: kode.kodepos,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (type === 'ktp') {
                  this.listkelurahan = resdata.data;
                  this.addpenduduk.kec_ktp = kode.kecamatan;
                  this.addpenduduk.kab_ktp = kode.kabupaten;
                } else {
                  this.listkelurahanadat = resdata.data;
                  this.addpenduduk.kec_adat = kode.kecamatan;
                  this.addpenduduk.kab_adat = kode.kabupaten;
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getKelurahan(kode, type) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/kelurahan',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listkelurahanall = resdata.data;
                this.impatlet.lokasi = this.listkelurahanall[0];
                // console.log(this.impatlet.lokasi);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getKodepos() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/kode',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listkodepos = resdata.data;
                this.listkodeposadat = resdata.data;
                // alamat ktp
                this.addpenduduk.pos_ktp = this.listkodepos[0];
                this.getKelurahanpos(this.addpenduduk.pos_ktp, 'ktp');
                // alamat adat
                this.addpenduduk.pos_adat = this.listkodeposadat[0];
                this.getKelurahanpos(this.addpenduduk.pos_adat, 'adat');
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getPekerjaan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listpekerjaan = resdata.data;
                this.addpenduduk.pekerjaan = this.listpekerjaan[0].nama_kerja;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getOlga() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenisolga/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then(async (res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listolga = resdata.data;
                this.addpenduduk.cabang_olga = this.listolga[0].nama_olga;
                this.searchpenduduk.cabang_olga = this.listolga[0].nama_olga;
                this.searchver.cabang_olga = this.listolga[0].nama_olga;
                await this.getPenduduk('ya');
                await this.getPenduduk('tidak');
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getStatusAdat() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenispenduduk/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.liststatusadat = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    downloadPenduduk() {
      // if (this.tokenscr) {
      //   this.axios
      //     .get(
      //       this.api + '/api/penduduk/download',
      //       {
      //         params: {
      //         },
      //         headers: {
      //           Authorization: 'bearer ' + this.tokenscr,
      //         },
      //       },
      //     )
      //     .then((res) => {
      //       console.log(res);
      //       // if (res.status === 200) {
      //       //   const resdata = res.data;
      //       //   if (resdata.error === false) {
      //       //     this.datalist = resdata.data;
      //       //   }
      //       // }
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // }
    },
    async getPenduduk(statusver) {
      this.loading.dataatlet = true;
      if (this.tokenscr) {
        // cek param
        let dataparam;
        if (statusver === 'tidak') {
          this.searchver.status_ver = statusver;
          dataparam = this.searchver;
        } else {
          this.searchpenduduk.status_ver = statusver;
          dataparam = this.searchpenduduk;
        }
        // get data
        this.axios
          .get(
            this.api + '/api/penduduk/',
            {
              params: dataparam,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (statusver === 'tidak') {
                  this.datalistver = resdata.data;
                  // console.log(this.datalistver);
                } else {
                  this.datalist = resdata.data;
                  // console.log(this.datalist);
                }
              }
            }
            this.loading.dataatlet = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.dataatlet = false;
          });
      }
    },
    submitAddNew() {
      // console.log('add new');
      // console.log(this.addpenduduk);
      this.alertdata.show = false;
      if (this.$refs.step4.validate()) {
        if (this.tokenscr) {
          const dataadd = this.addpenduduk;
          const formData = new FormData();
          // file image
          formData.append('file_ktp', dataadd.file_ktp);
          // data diri
          formData.append('jenisdata', dataadd.jenisdata);
          formData.append('nik', dataadd.nik);
          formData.append('nama', dataadd.nama);
          formData.append('tanggal_lahir', dataadd.tanggal_lahir);
          formData.append('tempat_lahir', dataadd.tempat_lahir);
          formData.append('kelamin', dataadd.kelamin);
          formData.append('agama', dataadd.agama);
          formData.append('pendidikan', dataadd.pendidikan);
          formData.append('pekerjaan', dataadd.pekerjaan);
          formData.append('email', dataadd.email);
          formData.append('phone', dataadd.phone);
          formData.append('status_menikah', dataadd.status_menikah);
          // alamat ktp
          formData.append('alamat', dataadd.alamat);
          formData.append('kab_ktp', dataadd.kab_ktp);
          formData.append('kec_ktp', dataadd.kec_ktp);
          formData.append('kel_ktp', dataadd.kel_ktp);
          formData.append('pos_ktp', dataadd.pos_ktp.kodepos);
          formData.append('banjar_ktp', dataadd.banjar_ktp);
          // alamat adat
          formData.append('status_adat', dataadd.status_adat);
          formData.append('alamat_adat', dataadd.alamat_adat);
          formData.append('kab_adat', dataadd.kab_adat);
          formData.append('kec_adat', dataadd.kec_adat);
          formData.append('kel_adat', dataadd.kel_adat);
          formData.append('pos_adat', dataadd.pos_adat.kodepos);
          formData.append('banjar_adat', dataadd.banjar_adat);
          // dalung
          formData.append('cabang_olga', dataadd.cabang_olga);
          // send data
          this.axios
            .post(
              this.api + '/api/penduduk/registernew',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  // this.$refs.formaddpenduduk.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Atlet "' + dataadd.nik + '" berhasil ditambahkan!';
                  this.redirectDetail({ name: 'PendudukDetailAdmin', query: { nik: dataadd.nik }}, 5000);
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    redirectDetail(direction, delay) {
      const thisVue = this;
      setTimeout(() => (thisVue.$router.push(direction)), delay);
    },
    closeDmodal(type) {
      if (type === 'penduduk') {
        this.dmodal.penduduk = false;
      } else if (type === 'detail') {
        this.dmodal.detail = false;
      } else {
        this.dmodal.penduduk = false;
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  html.overflow-y-hidden {
    overflow-y: hidden !important;
  }
</style>
